import { makeLogger } from '@dce-front/util-logger';
import { getPublicConfig } from '../config/config-helper.ts';

// @todo init logger for tv from config like logger for web (initLoggerWeb), and remove the default logger configuration below.
// This is a default configuration that'll be used for tv
let logger: ReturnType<typeof makeLogger> = makeLogger({
  isActive: false,
  level: 'info',
  format: 'json',
});

export const initLoggerWeb = () => {
  const { client, server } = getPublicConfig().log;
  logger = makeLogger(IS_SERVER ? server : client);
};

const Logger = () => {
  return logger;
};

export default Logger;
